import type { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { readApiError, getFieldErrors, DEFAULT_ERROR_MESSAGE } from '@/services/api';

type LaravelValidationErrors = Record<string, string[]>;

export interface MutationErrorResult {
    handled: boolean;
    status?: number;
    fieldErrors?: LaravelValidationErrors;
}

export function handleUserMutationError(error: unknown): MutationErrorResult {
    const status = (error as AxiosError).response?.status;
    const fieldErrors = getFieldErrors(error);

    if (status === 422 && Object.keys(fieldErrors).length > 0) {
        return { handled: true, status, fieldErrors };
    }
    if (status === 403) {
        toast.error('Insufficient permissions');
        return { handled: true, status };
    }
    // Was: body?.message ?? body?.error ?? '...'  -- which renders "[object Object]"
    // the moment `error` is the envelope object and the top-level message compat
    // key is gone (slice 3). readApiError() type-discriminates instead.
    const { message } = readApiError((error as AxiosError).response?.data);
    toast.error(status === 409 && message === DEFAULT_ERROR_MESSAGE
        ? 'This action conflicts with the current state'
        : message);
    return { handled: true, status };
}

export function formatFieldErrors(fieldErrors: LaravelValidationErrors): string {
    return Object.entries(fieldErrors)
        .map(([field, messages]) => `${field}: ${messages[0]}`)
        .join('; ');
}
